// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customizedscroling {
    inline-size: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    block-size: 695px;
    background: linear-gradient(to right, #eff2f7 0%, rgba(215, 238, 252, 0.6) 25%, #d0e4f9 50%, rgba(197, 231, 252, 0.6) 75%, #ffffff 100%);
}

.databigdata {
    margin-block-start: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-inline-start: auto;
    margin-inline-end: auto;
}

.datascience,
.bigdata {
    background: linear-gradient(135deg, #5483B3, #052659);
    color: white;
    border: none;
    cursor: pointer;
    transition: transform 0.3s ease;
    inline-size: 200px;
    block-size: 40px;
    border-radius: 10px;
    font-family: var(--font-stack-heading);
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: 0;
    font-size: 20px;
    text-align: center;
    padding-block-end: 4px;
    font-display: swap;

}

.bigdata {
    margin-inline-start: 20px;
}

.datascience:hover,
.bigdata:hover {
    background: linear-gradient(135deg, #052659, #5483B3);
    transform: scale(1.1) translateY(-1px);
}

.students-datascience1 {
    margin-block-start: 20px;
    margin-inline-start: 540px;
}

.students-datascience1-h1 {
    font-weight: 700;
    font-size: 40px;
    text-align: start;
    color: white;
}


/* Styles for phone screens */

@media (max-width: 480px) {
    .customizedscroling {
        block-size: 632px;
        padding-block-end: 20px;
    }
    .databigdata {
        flex-direction: column;
        margin-block-start: 20px;
    }
    .datascience,
    .bigdata {
        text-align: center;
        margin-block-start: 10px;
    }
    .bigdata {
        margin-inline-start: 20px;
    }
    .datascience {
        margin-inline-start: 20px;
    }
}


/* Tablet Styling */

@media (min-width: 481px) and (max-width: 1023px),
(min-width : 768px) and (max-width : 1023px),
(min-width : 1024px) and (max-width : 1279px) {
    .customizedscroling {
        inline-size: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        block-size: 590px;
    }
    .databigdata {
        margin-block-start: 20px;
        display: flex;
    }
    .datascience,
    .bigdata {
        text-align: center;
        margin-block-start: 10px;
    }
    .bigdata {
        margin-inline-start: 20px;
    }
    .datascience {
        margin-inline-start: 20px;
    }
    form {
        display: block;
        margin-block-start: 0em;
    }
    fieldset {
        border-style: groove;
        border-color: rgb(192, 192, 192);
    }
    .customised {
        text-align: center;
        margin-inline-start: 40px;
        font-size: 30px;
        font-weight: 400;
        font-family: 'Lato', sans-serif;
        margin-block-start: 30px;
    }
    .role1 {
        margin-inline-end: 90px;
    }
    .role2 {
        margin-inline-end: 20px;
    }
    .role3 {
        margin-inline-end: 10px;
    }
    select {
        inline-size: 380px;
    }
    .customised1 {
        text-align: center;
        font-size: 20px;
        font-weight: 400;
        font-family: 'Lato', sans-serif;
        margin-block-start: 30px;
    }
    .datascienceLink-link.active {
        transform: translateX(-20px);
        color: black !important;
        margin-block-start: 0px;
        margin-block-end: 0px;
    }
    .datascienceLink-link.active .customised {
        text-align: center;
        margin-inline-start: 0px;
        font-size: 30px;
        font-weight: 400;
        font-family: 'Lato', sans-serif;
        margin-block-start: 0px;
    }
    .bigdataLink-link.active {
        transform: translateX(0px);
        margin-block-start: 6px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Customized.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wIAAwI;AAC5I;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;;IAEI,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;;AAEtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,qDAAqD;IACrD,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;;AAGA,6BAA6B;;AAE7B;IACI;QACI,iBAAiB;QACjB,uBAAuB;IAC3B;IACA;QACI,sBAAsB;QACtB,wBAAwB;IAC5B;IACA;;QAEI,kBAAkB;QAClB,wBAAwB;IAC5B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;AACJ;;;AAGA,mBAAmB;;AAEnB;;;IAGI;QACI,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,wBAAwB;QACxB,aAAa;IACjB;IACA;;QAEI,kBAAkB;QAClB,wBAAwB;IAC5B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,cAAc;QACd,uBAAuB;IAC3B;IACA;QACI,oBAAoB;QACpB,gCAAgC;IACpC;IACA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,+BAA+B;QAC/B,wBAAwB;IAC5B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,+BAA+B;QAC/B,wBAAwB;IAC5B;IACA;QACI,4BAA4B;QAC5B,uBAAuB;QACvB,uBAAuB;QACvB,qBAAqB;IACzB;IACA;QACI,kBAAkB;QAClB,wBAAwB;QACxB,eAAe;QACf,gBAAgB;QAChB,+BAA+B;QAC/B,uBAAuB;IAC3B;IACA;QACI,0BAA0B;QAC1B,uBAAuB;IAC3B;AACJ","sourcesContent":[".customizedscroling {\n    inline-size: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    block-size: 695px;\n    background: linear-gradient(to right, #eff2f7 0%, rgba(215, 238, 252, 0.6) 25%, #d0e4f9 50%, rgba(197, 231, 252, 0.6) 75%, #ffffff 100%);\n}\n\n.databigdata {\n    margin-block-start: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-inline-start: auto;\n    margin-inline-end: auto;\n}\n\n.datascience,\n.bigdata {\n    background: linear-gradient(135deg, #5483B3, #052659);\n    color: white;\n    border: none;\n    cursor: pointer;\n    transition: transform 0.3s ease;\n    inline-size: 200px;\n    block-size: 40px;\n    border-radius: 10px;\n    font-family: var(--font-stack-heading);\n    font-weight: 700;\n    line-height: 1.2;\n    letter-spacing: 0;\n    font-size: 20px;\n    text-align: center;\n    padding-block-end: 4px;\n    font-display: swap;\n\n}\n\n.bigdata {\n    margin-inline-start: 20px;\n}\n\n.datascience:hover,\n.bigdata:hover {\n    background: linear-gradient(135deg, #052659, #5483B3);\n    transform: scale(1.1) translateY(-1px);\n}\n\n.students-datascience1 {\n    margin-block-start: 20px;\n    margin-inline-start: 540px;\n}\n\n.students-datascience1-h1 {\n    font-weight: 700;\n    font-size: 40px;\n    text-align: start;\n    color: white;\n}\n\n\n/* Styles for phone screens */\n\n@media (max-width: 480px) {\n    .customizedscroling {\n        block-size: 632px;\n        padding-block-end: 20px;\n    }\n    .databigdata {\n        flex-direction: column;\n        margin-block-start: 20px;\n    }\n    .datascience,\n    .bigdata {\n        text-align: center;\n        margin-block-start: 10px;\n    }\n    .bigdata {\n        margin-inline-start: 20px;\n    }\n    .datascience {\n        margin-inline-start: 20px;\n    }\n}\n\n\n/* Tablet Styling */\n\n@media (min-width: 481px) and (max-width: 1023px),\n(min-width : 768px) and (max-width : 1023px),\n(min-width : 1024px) and (max-width : 1279px) {\n    .customizedscroling {\n        inline-size: 100%;\n        overflow-x: hidden;\n        overflow-y: auto;\n        block-size: 590px;\n    }\n    .databigdata {\n        margin-block-start: 20px;\n        display: flex;\n    }\n    .datascience,\n    .bigdata {\n        text-align: center;\n        margin-block-start: 10px;\n    }\n    .bigdata {\n        margin-inline-start: 20px;\n    }\n    .datascience {\n        margin-inline-start: 20px;\n    }\n    form {\n        display: block;\n        margin-block-start: 0em;\n    }\n    fieldset {\n        border-style: groove;\n        border-color: rgb(192, 192, 192);\n    }\n    .customised {\n        text-align: center;\n        margin-inline-start: 40px;\n        font-size: 30px;\n        font-weight: 400;\n        font-family: 'Lato', sans-serif;\n        margin-block-start: 30px;\n    }\n    .role1 {\n        margin-inline-end: 90px;\n    }\n    .role2 {\n        margin-inline-end: 20px;\n    }\n    .role3 {\n        margin-inline-end: 10px;\n    }\n    select {\n        inline-size: 380px;\n    }\n    .customised1 {\n        text-align: center;\n        font-size: 20px;\n        font-weight: 400;\n        font-family: 'Lato', sans-serif;\n        margin-block-start: 30px;\n    }\n    .datascienceLink-link.active {\n        transform: translateX(-20px);\n        color: black !important;\n        margin-block-start: 0px;\n        margin-block-end: 0px;\n    }\n    .datascienceLink-link.active .customised {\n        text-align: center;\n        margin-inline-start: 0px;\n        font-size: 30px;\n        font-weight: 400;\n        font-family: 'Lato', sans-serif;\n        margin-block-start: 0px;\n    }\n    .bigdataLink-link.active {\n        transform: translateX(0px);\n        margin-block-start: 6px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
